/* eslint-disable react/prop-types */
import * as React from 'react';

import { Collapse } from 'antd';

import { cn } from 'utils';

const PrimitiveCollapse = React.forwardRef<
  React.ElementRef<typeof Collapse>,
  React.ComponentPropsWithoutRef<typeof Collapse>
>(
  (
    { size = 'large', expandIconPosition = 'end', className, ...props },
    ref,
  ) => (
    <Collapse
      ref={ref}
      size={size}
      expandIconPosition={expandIconPosition}
      className={cn(
        'my-2.5 overflow-x-auto bg-slate-50 last-of-type:mb-0 [&_.ant-collapse-header]:py-5',
        className,
      )}
      {...props}
    />
  ),
);
PrimitiveCollapse.displayName = 'PrimitiveCollapse';

export { PrimitiveCollapse };
